/* eslint-disable no-useless-return */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import FormSpinner from '../../common/utility/FormSpinner';
import FormMessage from '../../common/utility/FormMessage';
import FormBuilder from '../helpers/form-builder';
import * as signInFormActions from '../../../store/actions/sign-in-form-actions';
import * as upgradeAccountFormActions from '../../../store/actions/upgrade-account-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import initialState from '../helpers/form-helpers/initial-state';
import { isEmpty } from '../../utils/obj-utils';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import SSOFormHeader from '../../common/utility/SSOFormHeader';
import { ssoFormTypes } from '../../utils/form-types';
import { hasValue } from '../../../../../general/js/general-helpers';
import * as upgradeFormHelper from '../helpers/form-helpers/upgrade-form-helper';
import * as signInFormHelpers from '../helpers/form-helpers/sign-in-form-helpers';
import {
    MembershipTypes,
    getParameterByName,
    reloadPage,
    reloadToBasePage
} from '../../../../../general/js/utils';
import { QueryConstants } from '../../../../../general/js/utils/query-constants';
import { siteConstants } from '../../utils/constants/sites-constants';
import { getWebsiteDomain } from '../../../../../general/js/helpers';

class NewPasswordRequiredForm extends Component {
    constructor(props) {
        super(props);

        this.state = initialState.newPasswordRequiredFormState;
        this.displayForm = this.displayForm.bind(this);
        this.displayNewPasswordRequiredForm = this.displayNewPasswordRequiredForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.submitNewPasswordData = this.submitNewPasswordData.bind(this);
        this.handleSignInSuccess = this.handleSignInSuccess.bind(this);
        this.loadNewPasswordRequiredForm = this.loadNewPasswordRequiredForm.bind(this);
        this.loadSSOSignInSuccessFormData = this.loadSSOSignInSuccessFormData.bind(this);
        this.loadSSOUpgradeToOneClubFormData = this.loadSSOUpgradeToOneClubFormData.bind(this);
        this.getNextComponentToRender = this.getNextComponentToRender.bind(this);

        this.loadNewPasswordRequiredForm();
        this.loadSSOSignInSuccessFormData();
    }

    loadNewPasswordRequiredForm() {
        const {
            actions,
            cognitoUser,
            onSignIn,
            formData
        } = this.props;

        if (isEmpty(cognitoUser)) {
            onSignIn();
            return;
        }

        if (isEmpty(formData)) {
            actions.loadNewPasswordRequiredFormData();
        }
    }

    loadSSOSignInSuccessFormData() {
        const { actions } = this.props;

        actions.loadSSOSignInSuccessFormData();
    }

    loadSSOUpgradeToOneClubFormData() {
        const { actions } = this.props;

        actions.loadSSOUpgradeToOneClubFormData();
    }

    componentWillReceiveProps(nextProps) {
        const {
            isNewPasswordSavedSuccessful,
            loading,
            cognitoUser
        } = nextProps;

        if (!loading && isNewPasswordSavedSuccessful) {
            this.handleSignInSuccess(cognitoUser, nextProps);
            return;
        }

        if (!loading && !isNewPasswordSavedSuccessful) {
            this.setState(formStateHelpers.updateProcessingState(false));
        }
    }

    componentWillUnmount() {
        const { actions } = this.props;
        this.setState(initialState.signInFormState);
        actions.resetSignInFormState();
    }

    handleSignInSuccess(cognitoUser, nextProps) {
        const { onResetSuccess, signInSuccessFormData, upgradeToOneClubFormData } = nextProps;

        const website = getWebsiteDomain();
        if (!hasValue(upgradeToOneClubFormData) && website === siteConstants.theOpen) {
            this.loadSSOUpgradeToOneClubFormData();
        }

        this.setState(formStateHelpers.updateProcessingState(false), () => {
            const isOneClub = cognitoUser.challengeParam.userAttributes['custom:Membership'].includes(MembershipTypes.OneClub);
            const optIns = JSON.parse(cognitoUser.challengeParam.userAttributes['custom:OptIns']);


            if (isOneClub && website === siteConstants.theOpen) {
                //check if should render upgrade to One Club account
                if (hasValue(upgradeToOneClubFormData)) {
                    const currentUser = upgradeToOneClubFormData.currentUser;
                    const hasOneClubRequiredFields = upgradeFormHelper.hasOneClubRequiredFields(currentUser, optIns);
                    if (!hasOneClubRequiredFields) {
                        onResetSuccess(upgradeToOneClubFormData, ssoFormTypes.UpgradeToOneClubAccountFromDefault);
                        return;
                    }
                }
            } else {
                const hasAgreeToPrivacyPolicyChecked = signInFormHelpers.hasAgreeToPrivacyPolicyChecked(optIns);

                if (!hasAgreeToPrivacyPolicyChecked) {
                    onResetSuccess(signInSuccessFormData, ssoFormTypes.SignInSuccess);
                    return;
                }

                if (isEmpty(getParameterByName(QueryConstants.SHOW_POPUP))) {
                    reloadPage();
                    return;
                }

                reloadToBasePage();
            }
        });
    }

    getNextComponentToRender(optIns) {
        if (optIns.agreedToPrivacyPolicy === undefined || optIns.agreedToPrivacyPolicy === false) return true;

        return false;
    }

    displayForm() {
        const {
            loading,
            onSignIn,
            isNewPasswordSavedSuccessful,
            newPasswordSavedMessages,
            isNewPasswordRequiredFormDataLoadedSuccessful,
            loadPasswordRequiredFormDataMessages,
            formData
        } = this.props;
        const { formTitle } = formData;

        if (!loading &&
            !isNewPasswordRequiredFormDataLoadedSuccessful &&
            isEmpty(formData)) {
            return <Fragment>
                <SSOFormHeader
                    headerTitle={formMessageConstants.newPasswordRequired}
                    linkCallBackUrl={onSignIn}
                    headerLinkText={formMessageConstants.signInWithDifferentAccount}
                ></SSOFormHeader>
                <FormMessage
                    isSuccessMessage={isNewPasswordRequiredFormDataLoadedSuccessful}
                    messages={loadPasswordRequiredFormDataMessages}></FormMessage>
            </Fragment>;
        }

        if (isEmpty(formData)) {
            return null;
        }

        return (
            <Fragment>
                <SSOFormHeader
                    headerTitle={formTitle}
                    linkCallBackUrl={onSignIn}
                    headerLinkText={formMessageConstants.signInWithDifferentAccount}
                ></SSOFormHeader>
                <form onSubmit={this.handleSubmit}>
                    <FormMessage
                        isSuccessMessage={isNewPasswordSavedSuccessful}
                        messages={newPasswordSavedMessages}></FormMessage>
                    {this.displayNewPasswordRequiredForm()}
                    <SSOFormFooter
                        onSubmit={this.handleSubmit}
                        footerButtonText={formMessageConstants.changePassword}
                    >
                    </SSOFormFooter>
                </form>
            </Fragment>);
    }

    displayNewPasswordRequiredForm() {
        const { formData } = this.props;

        return FormBuilder({
            formData,
            formReferences: this.formReferences,
            handleFieldChange: (event) => {
                this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target));
            },
            handleConfirmPasswordChange: (event) => { this.setState(formStateHelpers.handleConfirmPasswordFieldChange(event.target)); },
            handleFieldValidState: (fieldName) => {
                const { errors } = this.state;
                return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors);
            }
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const { formData } = this.props;
        this.setState(formStateHelpers.handleFormValidation(formData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            return;
        }

        this.setState(formStateHelpers.updateProcessingState(true), this.submitNewPasswordData);
    }

    submitNewPasswordData() {
        const { actions, cognitoUser, formData } = this.props;
        const { password } = this.state;
        const { maxIdleTimeInSeconds } = formData;
        const actionSuccessText = formData.actionSuccessText || formMessageConstants.newPasswordRequiredSuccessText;

        actions.handleNewPasswordRequired({
            password,
            cognitoUser,
            maxIdleTimeInSeconds,
            actionSuccessText
        });
    }

    render() {
        const { isProcessing } = this.state;
        const { loading } = this.props;
        return (
            <div className='modal__content form-container'>
                <div className='auto-ph-md auto-p-md constrain-tablet ff-founders fs-14'>
                    <br />
                    {(isProcessing || loading) ? <FormSpinner>/</FormSpinner> : null}
                    {this.displayForm()}
                </div >
            </div >
        );
    }
}

NewPasswordRequiredForm.propTypes = {
    loading: PropTypes.bool.isRequired,
    onSignIn: PropTypes.func.isRequired,
    cognitoUser: PropTypes.object.isRequired,
    onResetSuccess: PropTypes.func.isRequired,
    signInSuccessFormData: PropTypes.object
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        isNewPasswordRequiredFormDataLoadedSuccessful: state.signInForm.isNewPasswordRequiredFormDataLoadedSuccessful,
        loadPasswordRequiredFormDataMessages: state.signInForm.loadPasswordRequiredFormDataMessages,
        formData: state.signInForm.newPasswordRequiredFormData,
        isNewPasswordSavedSuccessful: state.signInForm.isNewPasswordSavedSuccessful,
        newPasswordSavedMessages: state.signInForm.newPasswordSavedMessages,
        signInSuccessFormData: state.signInForm.signInSuccessFormData,
        upgradeToOneClubFormData: state.upgradeAccountForm.upgradeToOneClubFormData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            loadNewPasswordRequiredFormData: bindActionCreators(signInFormActions.loadNewPasswordRequiredFormData, dispatch),
            handleNewPasswordRequired: bindActionCreators(signInFormActions.handleNewPasswordRequired, dispatch),
            resetSignInFormState: bindActionCreators(signInFormActions.resetSignInFormState, dispatch),
            loadSSOSignInSuccessFormData: bindActionCreators(signInFormActions.loadSSOSignInSuccessFormData, dispatch),
            loadSSOUpgradeToOneClubFormData: bindActionCreators(upgradeAccountFormActions.loadSSOUpgradeToOneClubFormData, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewPasswordRequiredForm);
